export default {
  state: {
    facilityList: [],

    surveySkipList: [],

    keyOutDateDict: {},
  },
  getters: {
    getFacilityList(state) {
      return state.facilityList;
    },
    getSurveySkipList(state) {
      return state.surveySkipList;
    },
    getKeyOutDateDict(state) {
      return state.keyOutDateDict;
    }
  },
  mutations: {
    SET_FACILITY_LIST(state, data) {
      state.facilityList = data;
    },
    ADD_TO_SURVEY_SKIP_LIST(state, id) {
      state.surveySkipList.push(id);
    },
    SET_KEY_OUT_DATE_DICT(state, data) {
      state.keyOutDateDict[data.id] = data.data;
    }
  },
};
